import { Link } from "react-router-dom";
import { leagues } from "@/mocks/leagues";

export default function LeagueStrip() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-5 md:mb-7">
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 tracking-tight">
              热门联赛
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">
              一键进入你关注的联赛，查看全部赛程与直播
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {leagues.map((lg) => (
            <Link
              key={lg.key}
              to={`/category/${lg.key}`}
              className="group relative h-28 md:h-32 rounded-lg overflow-hidden border border-background-200 cursor-pointer"
            >
              <img
                src={lg.cover}
                alt={`${lg.name} 足球赛事直播`}
                title={`${lg.name} 直播与回放`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-black/10" />
              <div className="relative z-10 h-full flex flex-col justify-end p-3">
                <span className="font-heading text-lg text-white font-semibold">
                  {lg.name}
                </span>
                <span className="text-[11px] text-white/70 truncate">{lg.en}</span>
              </div>
              <span className="absolute top-2 right-2 w-6 h-6 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-up-line text-sm" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}